import { MedicalRecordsTemplate } from '@/ui/templates';
import { MedicalRecordsPage } from './MedicalRecordsPage';
import { ActionsPanel, DropZone } from './components';

export const MedicalRecordsContainer = () => {
  return (
    <MedicalRecordsTemplate
      isDataLoading={false}
      actionsPanel={<ActionsPanel />}
      content={
        <>
          <MedicalRecordsPage />
          <DropZone />
        </>
      }
    />
  );
};
